module.exports = __webpack_public_path__ + "media/images/athletes/3595-a986944e427769c697be215e7645727c.png";